import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from 'rhinostyle';
import { toggleModal } from '../reducers/threadReducer';
import { MODAL_OPTIONS } from '../constants/ThreadConstants';
import EmptyMessage from './EmptyMessage';

const BrowserNotSupportedModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.thread[MODAL_OPTIONS.browserNotSupported]);
  function handleToggleModal() {
    dispatch(toggleModal(MODAL_OPTIONS.browserNotSupported));
  }
  return (
    <Modal open={isOpen}>
      <ModalHeader title="Browser Not Supported" onClose={handleToggleModal} />
      <ModalBody>
        <EmptyMessage section="RhinoVideo Browser Not Supported" />
        <div className="u-text-center"><Button type="primary" onClick={handleToggleModal}>Close This Window</Button></div>
      </ModalBody>
    </Modal>
  );
};

export default BrowserNotSupportedModal;
